export default {
  tabTitle: 'Modelos de Referência de Conhecimento Especializado',
  createEkrm: 'Criar EKRM',
  search: 'Buscar',
  edit: 'Editar',
  close: 'Fechar',
  clone: 'Clonar',
  deleteEkrm: 'Excluir EKRM',
  printJsonToConsole: 'Imprimir JSON no console',
  downloadPkl: 'Baixar PKL',
  headerName: 'Nome',
  headerMarket: 'Mercado',
  headerCreatedOn: 'Criado em',
  headerCreatedBy: 'Criado por',
  headerActions: 'Ações',
  building: 'Construindo...',
  updating: '(Atualizando...)',
  draftDialogTitle: 'Criar EKRM',
  draftDialogText: 'Você já começou a criar um EKRM. Deseja continuar com esse, ou descartá-lo permanentemente e começar do zero?',
  continueBtn: 'Continuar',
  startFromScratchBtn: 'Começar do zero',
  deleteDialogTitle: 'Aviso',
  deleteDialogText: 'Excluindo EKRM:',
  deleteDialogConfirm: 'Você poderá recuperá-lo durante 7 dias solicitando a um administrador. Tem certeza?',
  deleteDialogConfirmBuilding: 'Esta ação não pode ser desfeita. Tem certeza?',
  cancelBtn: 'Cancelar',
  deleteBtn: 'Excluir',
  snackEkrmDeleted: 'EKRM excluído',
  snackErrorDeletingEkrm: 'Erro ao excluir EKRM',
  snackEkrmRenamed: 'EKRM renomeado',
  snackErrorRenamingEkrm: 'Erro ao renomear EKRM',
  snackPklDownloadStarted: 'Download de PKL iniciado',
  snackErrorDownloadingPkl: 'Erro ao baixar arquivo PKL',
  inputTooLong: 'Entrada muito longa!'
}
